"use strict";

exports.__esModule = true;

var Linkify = require("linkifyjs/html");

var format_message_1 = require("./format-message");
/**
 * Formats a console log message using the Devtools parser and returns HTML
 * @param args The arguments passed to the console method
 */


function formatMessage(args) {
  var formattedResult = document.createElement('span');
  format_message_1["default"](args[0], args.slice(1), formattedResult);
  return Linkify(formattedResult.outerHTML.replace(/(?:\r\n|\r|\n)/g, '<br />'));
}

exports["default"] = formatMessage;